import { render, staticRenderFns } from "./SectorArea.vue?vue&type=template&id=5e3ca7da&scoped=true&"
import script from "./SectorArea.vue?vue&type=script&lang=js&"
export * from "./SectorArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3ca7da",
  null
  
)

export default component.exports